/**
 * 云管家-智享薪
 */
export default [
  {
    label: '工作台',
    permission: 'home_page_menu',
    img: true,
    icon: 'icon-ic-zhuye',
    shortcut_icon: "bussiness-man",
    path: '/index?version=3',
    id:1,
  },
  {
    label: '人事管理',
    img: true,
    icon: 'icon-renshiguanli',
    id:3,
    children: [
      {
        path: '/per/toPerList.action?sysFunctionCode=OTA4NDAwMTY-',
        label: '员工管理',
        permission: 'hr_emp_manage',
        icon: 'icon-yonghu',
        id: 3-2,
      }
    ]
  },
  {
    label: '薪酬服务',
    // permission: 'wage_sys_menu',
    img: true,
    icon: 'icon-xinchoufuwu',
    id:5,
    children: [
      {
        path: '/wage/data-ready-template',
        label: '数据准备',
        permission: 'hr_wage__new_data_ready',
        icon: 'icon-yonghu',
        id:5-1
      },
      {
        path: '/wage/wageHistory',
        label: '薪酬历史',
        permission: 'hr_wage_new_his',
        icon: 'icon-yonghu',
        id: 5-2,

      },
      {
        path: '/wage/paymentWage',
        label: '薪酬发放',
        permission: 'hr_wage_new_pay',
        icon: 'icon-yonghu',
        id: 5-2,

      },
      {
        path: '/wage/salaryTax',
        label: '个税申报',
        permission: 'hr_wage_new_tax',
        icon: 'icon-yonghu',
        id: 5-2,

      },
      {
        path: '/payrollSettings/onePayHistory',
        label: '仅工资条',
        permission: 'hr_wage_new_only_wage',
        icon: 'icon-yonghu',
        id: 5-7,
      }
    ]
  },
  {
    label: '审批流程',
    // permission: 'hr_manage_menu',
    img: true,
    icon: 'icon-shenpiliucheng',
    id:6,
    children: [
      {
        path: '/wage/salaryApproval',
        label: '薪酬审批',
        permission: 'hr_wage_new_approve',
        icon: 'icon-yonghu',
        id: 6-1,

      },
    ]
  },
  {
    label: '数据统计',
    permission: 'hr_wage_new_report',
    img: true,
    icon: 'icon-tongjibaobiao',
    id:7,
    children: [
      {
        path: '/v2/stats/data-center',
        label: '数据中心',
        permission: 'hr_wage_new_report_data_center',
        icon: 'icon-yonghu',
        id: 7-11,
      },
      /*{
        path: '/wage/data-ready-template',
        label: '报表统计',
        permission: 'wage_data-ready-template_temp',
        icon: 'icon-yonghu',
        id:6-1
      },*/
      /*{
        path: '/wage/wageComparisonColumnsList',
        label: '工资对比报表',
        permission: 'wage_salary_yop',
        icon: 'icon-yonghu',
        id: 6-2,
      },*/
      {
        path: '/wage/costCenterSummaryColumnsList',
        label: '成本中心汇总表',
        permission: 'hr_wage_new_report_cbzx',
        icon: 'icon-yonghu',
        id: 7-3,
      },
      /*      {
              path: '/wage/taxRateSummaryList',
              label: '税率汇总报表',
              permission: 'wage_salary_yop',
              icon: 'icon-yonghu',
              id: 6-4,
            },*/
      /*{
        path: '/wage/averageWageColumnsList',
        label: '平均工资报表',
        permission: 'wage_salary_yop',
        icon: 'icon-yonghu',
        id: 6-5,
      },*/
      {
        path: '/report/wageComparison',
        label: '工资对比表',
        permission: 'hr_wage_new_report_gzdb',
        icon: 'icon-yonghu',
        id: 7-2,
      },
      {
        path: '/report/annualWage',
        label: '成本中心对比表',
        permission: 'hr_wage_new_report_cbzxdb',
        icon: 'icon-yonghu',
        id:7-6
      },
      {
        path: '/report/averageWage',
        label: '年度工资汇总表',
        permission: 'hr_wage_new_report_ndpjgz',
        icon: 'icon-yonghu',
        id:7-7
      },
      {
        path: '/report/annualAverageWage',
        label: '年度平均工资表',
        permission: 'hr_wage_new_report_ndpjgz',
        icon: 'icon-yonghu',
        id:7-8
      },
      {
        path: '/report/payReport',
        label: '雇员发薪明细',
        permission: 'hr_wage_new_report_xzmx',
        icon: 'icon-yonghu',
        id:7-9
      },
      {
        path: '/report/ReportCli',
        label: '自定义报表',
        permission: 'hr_wage_new_report_zdybb',
        icon: 'icon-yonghu',
        id: 7-10,
      },
    ]
  },
  {
    label: '系统管理',
    // permission: 'set_platform',
    img: '平台设置',
    icon: 'icon-pingtaishezhi',
    id:8,
    children: [
      {
        path: '/pms/roleInfoList.action',
        label: 'HR权限设置',
        permission: 'set_role',
        icon: 'icon-yonghu',
        id: 8-3,

      },
      {
        path: '/pms/userRoleList.action',
        label: '用户授权',
        permission: 'set_user_permission',
        icon: 'icon-yonghu',
        id: 8-4,
      },
      {
        path: '/wage/salarySet',
        label: '薪酬设置',
        permission: 'hr_wage_new_set',
        icon: 'icon-yonghu',
        id: 5-8,
      },
      {
        path: '/approval/toindex.action',
        label: '审批设置',
        permission: 'set_approve',
        icon: 'icon-yonghu',
        id: 6-2
      },
    ]
  },
  {
    label: '股票行权邮件管理',
    permission: 'set_email_management',
    icon: 'icon-shenpiliucheng',
    id:11,
    children: [
        {
        path: '/wage/teslaArrears',
        label: '欠款管理',
        permission: 'set_email_management_debt',
        component:'',
        icon: 'icon-yonghu',
        id: 11-1,
        },
        {
        path: '/wage/teslaEmali',
        label: '邮件设置',
        permission: 'set_email_management_mailSet',
        icon: 'icon-yonghu',
        id: 11-2,
        },
    ]
  }
]
